// Vidéo des sections dx. Classes posées : is-playing (en lecture), has-played (déjà lancée une fois).
// Sans data-autoplay : lecture au tap uniquement, une seule vidéo à la fois sur la page.
// Avec data-autoplay : boucle muette lancée quand la vidéo approche de l'écran (désactivée si l'utilisateur réduit les animations).
if (!customElements.get('dx-video')) {
  customElements.define(
    'dx-video',
    class DxVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.autoplay =
          this.hasAttribute('data-autoplay') && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.video.addEventListener('playing', () => this.classList.add('is-playing', 'has-played'));
        this.video.addEventListener('pause', () => this.classList.remove('is-playing'));

        if (this.autoplay) {
          this.observer = new IntersectionObserver(
            ([entry]) => {
              if (entry.isIntersecting) {
                this.video.muted = true;
                this.video.play().catch(() => {});
              } else {
                this.video.pause();
              }
            },
            { rootMargin: '200px 0px' }
          );
        } else {
          this.querySelector('[data-dx-play]')?.addEventListener('click', () => this.play());
          this.video.addEventListener('click', () => this.video.pause());
          this.onOtherPlay = (event) => {
            if (event.detail !== this) this.video.pause();
          };
          document.addEventListener('dx:video-play', this.onOtherPlay);
          // Une vidéo qui sort de l'écran est mise en pause.
          this.observer = new IntersectionObserver(([entry]) => {
            if (!entry.isIntersecting) this.video.pause();
          });
        }
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        if (this.onOtherPlay) document.removeEventListener('dx:video-play', this.onOtherPlay);
      }

      play() {
        document.dispatchEvent(new CustomEvent('dx:video-play', { detail: this }));
        this.video.play().catch(() => {});
      }
    }
  );
}
